import Url from 'urijs';
import { isEmpty } from 'lodash';

import { buildTargetUrlPreservingParams } from 'Utils/uri/uriUtils';
import { PHONE_URL_PROTOCOL } from './constants';

function getUrl(sUrl: string): Url {
  return new Url(sUrl);
}

function sameHostname(previousUrl: Url, nextUrl: Url): boolean {
  return (
    isEmpty(nextUrl.hostname()) ||
    (previousUrl.hostname() === nextUrl.hostname() && previousUrl.port() === nextUrl.port())
  );
}

export function getSpaUrl(url: Url): string {
  return getUrl(url.pathname()).query(url.query()).hash(url.hash()).toString();
}

export type DynamicLinkOptions = {
  propagateHashParams?: boolean;
};

class DynamicLinkUtil {
  previousUrl: Url;

  nextUrl: Url;

  targetUrl: Url;

  constructor(previousUrl: string | undefined, nextUrl: string, options?: DynamicLinkOptions) {
    if (!(this instanceof DynamicLinkUtil)) {
      // eslint-disable-next-line no-constructor-return
      return new DynamicLinkUtil(previousUrl, nextUrl, options);
    }
    this.previousUrl = previousUrl ? getUrl(previousUrl) : new Url();
    this.nextUrl = getUrl(nextUrl);
    this.targetUrl = this.isExternalUrl()
      ? this.nextUrl
      : buildTargetUrlPreservingParams(this.previousUrl, this.nextUrl, options);
  }

  hashToSamePage(): boolean {
    return (
      !isEmpty(this.nextUrl.hash()) &&
      (isEmpty(this.nextUrl.pathname()) || this.nextUrl.pathname() === this.previousUrl.pathname())
    );
  }

  isOpenLayerLink(): boolean {
    return this.nextUrl.hasQuery('openLayer');
  }

  isPhoneNumberUrl(): boolean {
    return this.nextUrl.protocol() === PHONE_URL_PROTOCOL;
  }

  isExternalUrl(): boolean {
    return !sameHostname(this.previousUrl, this.nextUrl) || this.isPhoneNumberUrl();
  }

  isSpaUrl(): boolean {
    return !this.isExternalUrl() && !this.hashToSamePage() && !this.isPhoneNumberUrl();
  }

  toString(): string {
    return this.isSpaUrl() ? getSpaUrl(this.targetUrl) : this.targetUrl.toString();
  }

  hash(): string {
    return this.targetUrl.hash();
  }
}

export default DynamicLinkUtil;
